var map = {
	"./img_1.png": 79563,
	"./img_2.png": 42545,
	"./img_3.png": 30792,
	"./img_4.png": 96285,
	"./img_5.png": 83659,
	"./img_6.png": 98482,
	"./img_7.png": 90942,
	"./img_8.png": 24262,
	"./img_9.png": 76111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30555;